
import { inject } from "vue";
import { useRouter } from "vue-router";
import {useStore} from '@/main'
export default {
  props: {
    data: {
      type: Object,
    },
  },
  setup(props: Object) {
    const $store: any = inject("$store");
    const currencyUnit = $store.getSymbol();
      const router = useRouter();
    let unifiedJump = async (item:any)=>{
     $store.setDetails({ ...item.goods });
                router.push({
                name:'goods',
                params:{
                    id:item.goods_id
                }
              })
    }
    return {
      currencyUnit,
      unifiedJump,
    };
  },
};
